export const appUtms = {
  utm_source: 'leadmagnet',
  utm_medium: 'prediagnostico',
}
